var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "70 30 120 210",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusFill {\n            fill: #2A6FAE;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer7",
    transform: "matrix(10,0,0,10,-70,-70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.596183,0,0,0.596183,7.87172,6.45084)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.343,
    cy: 16.017,
    r: 5.032,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,0.1,7,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.462,233.532L126.477,233.546C126.53,233.599 126.584,233.65 126.639,233.7L126.645,233.706C126.673,233.731 126.701,233.756 126.73,233.781L126.774,233.819C126.79,233.832 126.805,233.845 126.82,233.858L126.867,233.896L126.914,233.933C127.015,234.012 127.119,234.088 127.226,234.16C127.269,234.188 127.313,234.217 127.357,234.244C128.124,234.723 129.03,235 130,235C132.76,235 135,232.76 135,230C135,169.63 145.49,144.563 153.952,126.839C160.062,114.042 165,104.725 165,90C165,70.683 149.317,55 130,55C110.683,55 95,70.683 95,90C95,106.058 107.116,116.475 107.116,116.475C109.208,118.275 112.367,118.038 114.167,115.946C115.967,113.854 115.729,110.694 113.637,108.894C113.637,108.894 105,101.458 105,90C105,76.202 116.202,65 130,65C143.798,65 155,76.202 155,90C155,103.038 150.338,111.199 144.928,122.531C138.627,135.729 131.155,152.819 127.404,184.45C120.708,164.929 110.68,148.859 101.897,134.097C92.805,118.815 85,105.116 85,90C85,65.164 105.164,45 130,45C154.836,45 175,65.164 175,90C175,104.569 167.734,117.821 159.078,132.454C157.673,134.83 158.46,137.899 160.835,139.303C163.211,140.708 166.28,139.921 167.685,137.546C177.344,121.215 185,106.259 185,90C185,59.645 160.355,35 130,35C99.645,35 75,59.645 75,90C75,106.806 83.195,122.219 93.303,139.21C107.317,162.766 125,189.724 125,230C125,231.378 125.559,232.627 126.462,233.532Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.b0e79ac2677bb932c88c12fcce109aed.svg";
export { ForwardRef as ReactComponent };